import React, { useState, useCallback, memo, useMemo, useEffect } from 'react';
import getDeviceType from '@utility/deviceType';
import MenuCartbarHeader from './MenuCartBarHeader';
import MenuCartSeat from './MenuCartSeat';
import CartItems from './CartItems';
import CartButtons from './CartButtons';
import { LABEL } from '@veriables';
import { setVoidItemData, setVoidCheckOpen } from '@reducers/orders';
import { openManagerCheck, closeManagerCheck } from '@reducers/oauth';
import { repostPayment } from '@reducers/storeChecks';
import { setErrorPopUp } from '@reducers/notification';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import VoidCheckModal from './Modals/VoidCheckModal/index';
import { getObjectValue } from '@utility/utills';

const ManagerCheck = React.lazy(() =>
  import('@components/checksCommon/managerCheck')
);

const MenuCartBarV2 = ({
  setVoidItemData,
  setVoidCheckOpen,
  openManagerCheck,
  seat,
  auth,
  userInfo,
  isManagerCheck,
  voidCheckOpen,
  deviceInfo,
  repostPayment,
  setErrorPopUp,
  position,
}) => {
  const { isCounter, isCallCenter, isSpeedOrderMode, isDriveThru } = getDeviceType();

  const [isCheckBoxClicked, setIsCheckBoxClicked] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  const [isVoidOpen, setIsVoidOpen] = useState(false);
  const deviceType = getDeviceType();
  // Repost payment state
  const [isRepost, setIsRepost] = useState(false);
  const [repostConfirmation, setRepostConfirmation] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleRepostPayment = useCallback(() => {
    setIsRepost(true);
  }, []);

  const handleCloseRepost = useCallback(() => {
    setIsRepost(false);
  }, []);

  const repostPayments = useCallback(() => {
    const seatsData = JSON.parse(window.sessionStorage.getItem('seat'));
    const data = {
      storeId: deviceInfo?.storeId,
      deviceId: deviceInfo?.deviceId,
      employeeId: Number(userInfo?.id),
      ticketId: selectedItem?.ticketId,
      checkTicketId: selectedItem?.id,
      checkHeaderId: seatsData?.id,
    };
    repostPayment(data)
      .then(() => {
        setRepostConfirmation(false);
        setIsRepost(false);
      })
      .catch(err => {
        setRepostConfirmation(false);
        setErrorPopUp({ res: err.message });
      });
  }, [deviceInfo, userInfo, selectedItem, repostPayment, setErrorPopUp]);

  const tHead = React.useMemo(
    () => [
      { key: 'checkbox', name: '' },
      { key: 'cardType', name: LABEL().CARD_TYPE },
      { key: 'redactedCardNumber', name: LABEL().REDACTED_CARD_NUMBER },
      { key: 'cardHolderName', name: LABEL().NAME },
      {
        key: 'ticketAmount',
        name: LABEL().TOTAL,
        prefix: `${LABEL().CURRENCY_SYMBOL}`,
      },
      {
        key: 'tipAmount',
        name: LABEL().TIP,
        prefix: `${LABEL().CURRENCY_SYMBOL}`,
      },
      { key: 'paymentStatus', name: LABEL().PAYMENT },
    ],
    []
  );

  const handleManagerAuthentication = useCallback(
    (data = []) => {
      let itemsToVoid;

      if (data && data.length > 0) {
        itemsToVoid = data;
      } else if (isCheckBoxClicked) {
        itemsToVoid = seat?.Items?.filter(e => selectedItems[e.id]);
      } else {
        itemsToVoid = seat?.Items;
      }

      setVoidItemData(itemsToVoid);
      if (data) {
        setVoidCheckOpen(false);
      }
      const tileHead = data === null ? LABEL().VOID_CHECK : LABEL().VOID_ITEM;
      if (userInfo?.jobTypeId !== 1 && auth?.nonIntegratedPos) {
        openManagerCheck(tileHead);
      } else {
        setIsVoidOpen(true);
      }
    },
    [
      seat?.Items,
      isCheckBoxClicked,
      selectedItems,
      setVoidItemData,
      userInfo?.jobTypeId,
      auth?.nonIntegratedPos,
      openManagerCheck,
      voidCheckOpen,
      setVoidCheckOpen,
    ]
  );

  const resetCheckBoxState = useCallback(state => {
    setIsCheckBoxClicked(state);
    setSelectedItems({});
  }, []);

  // Uncheck all items when the user switches between seats or Table view.
  useEffect(() => {
    setIsCheckBoxClicked(false);
    setSelectedItems({});
  }, [position?.number, position?.seatId]);

  const handleSetVoidOpen = useCallback(state => {
    setIsVoidOpen(state);
  }, []);

  const enableItemHold = useMemo(
    () =>
      getObjectValue(
        () =>
          deviceInfo?.deviceGroup &&
          deviceInfo?.deviceGroup?.serverAppSettings?.enableItemHold,
        false
      ),
    [deviceInfo]
  );
  return (
    <div className="h-100 col-3 px-0 mx-0">
        <MenuCartbarHeader
          handleMangerAuthentication={handleManagerAuthentication}
          handleRepostPayment={handleRepostPayment}
          setSelectedItem={setSelectedItem}
          repostConfirmation={repostConfirmation}
          setRepostConfirmation={setRepostConfirmation}
          isRepost={isRepost}
          tHead={tHead}
          onClose={handleCloseRepost}
          repostPayments={repostPayments}
          isTogo={deviceType?.isTogo}
        />
      
      {!deviceType?.isTogo && !isCounter && !isCallCenter && !isDriveThru && !isSpeedOrderMode &&  <MenuCartSeat />}
      <CartItems
        isCheckBoxClicked={isCheckBoxClicked}
        setIsCheckBoxClicked={setIsCheckBoxClicked}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        handleManagerAuthentication={handleManagerAuthentication}
        isTogo={deviceType?.isTogo}
        enableItemHold={enableItemHold}
      />
      <CartButtons
        isCheckBoxClicked={isCheckBoxClicked}
        handleManagerAuthentication={handleManagerAuthentication}
        checkedItems={selectedItems}
        resetCheckBoxState={resetCheckBoxState}
        enableItemHold={enableItemHold}
      />
      {isManagerCheck && (
        <ManagerCheck
          setIsVoidOpen={handleSetVoidOpen}
          isSetupOffPremise={false}
          setIsSetupOffPremise={() => {}}
          type="cart"
        />
      )}
      {isVoidOpen && (
        <VoidCheckModal
          isVoidOpen={isVoidOpen}
          setIsVoidOpen={setIsVoidOpen}
          resetCheckBoxState={resetCheckBoxState}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ orders, oauth }) => ({
  seat: orders.seats,
  userInfo: oauth.loggedInUserData,
  auth: oauth.authInfo,
  isManagerCheck: oauth.isManagerCheck,
  voidCheckOpen: orders.voidCheckOpen,
  deviceInfo: oauth.deviceInformation,
  position: orders.position,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setVoidItemData,
      setVoidCheckOpen,
      openManagerCheck,
      closeManagerCheck,
      repostPayment,
      setErrorPopUp,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(MenuCartBarV2));
